import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import * as css from './EventMenu.css';
import EventMenuMenu from './eventMenuMenu/EventMenuMenu';
import {useTranslation} from 'react-i18next';
import {ThemeProvider} from 'styled-components';
import EventMenuStats from '../eventMenu/eventMenuStats/EventMenuStats';
import FormButton from './formButtton/FormButtton';
import SettingsPopup from '../../pages/eventSettings/settingsPopup/SettingsPopup';
import PopUpFrame from '../../component/popUpFrame/PopUpFrame';
import useShow from '../../hooks/useShow';
import {Else, If, Then} from 'react-if';
import useTablet from '../../hooks/useTablet';
import {Link} from 'react-router-dom';
import EventRolePermission from '../../pages/components/rolePermission/EventRolePermission';
import {LIVE_DOMAIN, TICK_DOMAIN} from '../../config/config';
import hasSpecificTranslate from '../../library/hasSpecificTranslate';
import HubSettingsPopup from '../../pages/eventSettings/hubSettingsPopup/HubSettingsPopup';
import {useLocation, useParams} from 'react-router-dom'; // 
import useEffectOnUpdate from '../../hooks/useEffectOnUpdate';
import useMobile from '../../hooks/useMobile';
import CustomScrollbar from '../../component/customScrollbar/CustomScrollbar';
import zIndex from '../../globalVariables/zIndex';
import {tsToDate} from '../../library/dates';
import useWideScreen from '../../hooks/useWideScreen';

function EventMenu(props) {
    const {t} = useTranslation('layout');
    const [miniDisplay, setMiniDisplay] = useState(0);
    const {page, subPage} = useParams();
    const oldSystem = useSelector(s => s.realtime.user.oldSystem);
    const {eid,timeStart,timeZone,title,type,fbImg,userEventRole} = useSelector(s => s.event);
    const isWideScreen = useWideScreen();
    const isSubscriptions = page === 'subscription' && isWideScreen;
    const isRealtime = (page === 'realtime' && !oldSystem && (['ticket', 'area','givechak','subscription'].includes(type))) || isSubscriptions;
    const location = useLocation();
    const isMobile = useMobile();

    const isTablet = useTablet();
    const eventTypsArr = {ticket: t('ticketEvent'), area: t('areaEvent'), timetable: t('timetableEvent'), givechak: t('givechak'), table: t('tableEvent'), frontpage: t('frontpage'), listing: t('listing'),cluster:t('cluster'),course:t('course')};
    let Langs = [];
    Langs['en'] = t('englishUs');
    Langs['he'] = t('hebrew');

    useEffect(() => {
        // publish/v2 is a dense data table — give it the full width like
        // the landing page (design) does.
        const isPublishV2 = page === 'publish' && subPage === 'v2';
        if(!isTablet && (isRealtime || page === 'design' || isPublishV2)){
            setMiniDisplay(1);
        }
        else {
            setMiniDisplay(0);
        }
    }, [page, subPage, isTablet]);

    useEffect(() => {
        if(props.updateMiniMenu)
            props.updateMiniMenu(miniDisplay);
    }, [miniDisplay]);

    useEffectOnUpdate(() => {
        if(props.closeMenu && isMobile)
            props.closeMenu();
    }, [location]);

    const ref = useRef(null);
    const {open, close, isOpen, showClass} = useShow( 500);

    let eventTypes = {
        hub:{Comp:HubSettingsPopup,domain:LIVE_DOMAIN},
        subscription:{Comp:HubSettingsPopup,domain:LIVE_DOMAIN},
        default:{Comp:SettingsPopup,domain:TICK_DOMAIN}
    };

    const {Comp,domain}= eventTypes[type]||eventTypes['default'];
    const containerRef = useRef(null);
    const cssStyle = `
        inset-inline-start: 5px;
        z-index: ${zIndex.baseHigh}
    `;
    return (
        <ThemeProvider theme={{mini: miniDisplay, realtime: isRealtime}}>
            {eid &&
                <css.EventMenu>
                    <css.EventMenuTopBack img={fbImg}>
                        <css.EventMenuTop>
                            <css.EventMenuHead>
                                {!isTablet && <css.EMHeadMini onClick={() => {
                                    setMiniDisplay(!miniDisplay);
                                }} />}
                                <css.EMHeadType>{eventTypsArr[type]}</css.EMHeadType>
                            </css.EventMenuHead>
                            {(!isRealtime || !miniDisplay) &&  <css.EMTitleFrame>
                                <css.EventMenuTitle data-cy={'sideMenuTitle'}>{title}</css.EventMenuTitle>
                                <css.EMTitleLeft>
                                    <css.EventMenuDate data-cy={'sideMenuDate'} >
                                        <If condition={timeStart}>
                                            <Then>
                                                {tsToDate(timeStart,'',timeZone)}{miniDisplay ? <br /> :
                                                    <span>*</span>}{tsToDate(timeStart,'',timeZone,'HH:mm')}
                                            </Then>
                                            <Else>
                                                {t('continuousEvent')}
                                            </Else>
                                        </If>
                                    </css.EventMenuDate>

                                </css.EMTitleLeft>
                            </css.EMTitleFrame>}
                        </css.EventMenuTop>
                    </css.EventMenuTopBack>
                    <css.bottomMenu>
                        {(!isRealtime || !miniDisplay) && <FormButton isMiniDisplay={miniDisplay} domain={domain}/>}
                        {(!isRealtime || !miniDisplay) && <css.wrapStats>
                            {type!=='hub' && userEventRole !== 'guide' && <><EventMenuStats mini={miniDisplay} />
                                <Link to={`/e/${eid}/realtime`}>
                                    <css.control data-cy="controlBtn">
                                        {t('control')}
                                    </css.control>
                                </Link> </>}
                        </css.wrapStats>}
                        <CustomScrollbar contentRef={containerRef} cssStyle={cssStyle}/>
                        <EventMenuMenu miniDisplay={miniDisplay} closeMenu={props.closeMenu} containerRef={containerRef}/>
                        <EventRolePermission rolePermission='manage event'>
                            <css.EventMenuBot>
                                {/*<css.EventMenuLang>*/}
                                {/*    <css.menuBotImg className={'lang'} />*/}
                                {/*    <css.menuBotText>{Langs[event.lang]}</css.menuBotText>*/}
                                {/*</css.EventMenuLang>*/}
                                <css.EventMenuDef data-cy="eventSettingBtn" onClick={open}>
                                    {/* <css.EventMenuDef onClick={() => iframeClick('settings')}> */}
                                    <css.menuBotImg className={'def'} />
                                    <css.menuBotText>{hasSpecificTranslate(`${type}Settings`,t)||t('eventSettings')}</css.menuBotText>
                                </css.EventMenuDef>
                            </css.EventMenuBot>
                        </EventRolePermission>
                    </css.bottomMenu>
                </css.EventMenu>
            }
            {isOpen &&
                <PopUpFrame showClass={showClass}>
                    <div ref={ref}>
                        <Comp showClass={showClass} close={close} />
                    </div>
                </PopUpFrame>
            }
        </ThemeProvider>
    );
}

export default EventMenu;
